import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



const cardData = {
  keyword: " Urbania On Rent in Pune ",

"headingDescription": "Urbania On Rent in Pune offers stylish, comfortable, and hassle-free transportation for city travel, weekend trips, and group outings. SRS Cab Service provides well-maintained Urbania vehicles with professional drivers to ensure a smooth ride across Pune. Whether it’s a corporate commute, family outing, or leisure trip, our rental service delivers flexible booking options, transparent fares, and 24/7 support to make your travel convenient, safe, and enjoyable.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a must-visit landmark in Pune. Travelers renting an Urbania often include this site in their itinerary to explore Pune’s rich Maratha heritage and architectural beauty."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant historical site associated with India’s freedom struggle. Visitors using Urbania on rent often stop here to enjoy its lush gardens and informative museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is known for its scenic views and trekking opportunities. Travelers renting an Urbania frequently plan a trip here to experience adventure and panoramic landscapes."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples. Visitors using Urbania on rent often visit to experience spiritual serenity and local devotional culture."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva. Travelers using Urbania on rent enjoy the peaceful ambiance and historic significance of this temple."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a remarkable collection of Indian artifacts. Visitors renting Urbania explore Pune’s cultural and artistic heritage through its sculptures and exhibits."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple provides panoramic views of Pune and historic temples. Travelers using Urbania often climb the hill to enjoy sightseeing and serene surroundings."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a tranquil getaway surrounded by hills and water. Visitors renting Urbania often relax here and capture scenic views, especially during the monsoon season."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped garden. Travelers using Urbania on rent enjoy walking through lush greenery and relaxing in this calm environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace linked to Chhatrapati Shivaji Maharaj. Visitors renting Urbania often explore this landmark to learn about Pune’s rich history and heritage."
  }
],



services: [
{
name: "Luxury Force Urbania on Rent in Pune",
description: "Luxury Force Urbania on rent in Pune offers premium group travel with high-end comfort. Customers can book Urbania vans for tours and events. Professional drivers ensure safe journeys. Spacious seating enhances travel experience. Ideal for corporate and family trips. Travel in style with luxury Urbania rentals."
},
{
name: "13 Seater Force Urbania on Rent in Pune",
description: "13 seater Force Urbania on rent in Pune provides comfortable travel for small groups. Customers can book vehicles for tours and outings. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with 13 seater Urbania rentals."
},
{
name: "17 Seater Force Urbania on Rent in Pune",
description: "17 seater Force Urbania on rent in Pune offers spacious travel for larger groups. Customers can book vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 17 seater Urbania services."
},
{
name: "Force Urbania for Rent in Pune",
description: "Force Urbania for rent in Pune provides reliable group travel solutions. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Spacious interiors enhance experience. Flexible booking options are available. Choose Urbania rentals for comfortable travel."
},
{
name: "Pune to Mahabaleshwar Urbania Bus on Rent",
description: "Pune to Mahabaleshwar Urbania bus on rent offers comfortable hill station travel. Customers can book vehicles for group trips. Professional drivers ensure safe ghat journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily to Mahabaleshwar with Urbania."
},
{
name: "Pune to Shirdi Urbania on Rent",
description: "Pune to Shirdi Urbania on rent provides convenient travel for pilgrimage trips. Customers can book vehicles for group darshan tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Shirdi with Urbania."
},
{
name: "Pune to Mumbai International Airport Urbania on Rent",
description: "Pune to Mumbai International Airport Urbania on rent offers premium airport transfers. Customers can book vehicles for group travel. Professional drivers ensure timely journeys. Spacious seating and luggage space enhance experience. Flexible booking options are available. Travel easily to Mumbai Airport with Urbania."
},
{
name: "Pune to Lonavala Urbania on Rent",
description: "Pune to Lonavala Urbania on rent offers comfortable travel for short trips. Customers can book vehicles for group outings. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily to Lonavala with Urbania services."
},
{
name: "Pune to Kolhapur Urbania Hire",
description: "Pune to Kolhapur Urbania hire provides reliable travel for long-distance trips. Customers can book vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from Pune to Kolhapur."
},
{
name: "Urbania on Rent in Pimpri Chinchwad",
description: "Urbania on rent in Pimpri Chinchwad offers convenient group travel solutions. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania rentals."
},
{
name: "Urbania on Rent in Koregaon Park Pune",
description: "Urbania on rent in Koregaon Park Pune provides premium travel options for city users. Customers can book vehicles for events and tours. Professional drivers ensure safe journeys. Spacious interiors enhance experience. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Urbania on Rent in Hadapsar",
description: "Urbania on rent in Hadapsar offers reliable transportation for group travel. Customers can book vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania rentals in Hadapsar."
},
{
name: "Urbania on Rent in Kharadi Pune",
description: "Urbania on rent in Kharadi Pune provides convenient travel solutions for groups. Customers can book vehicles for business and leisure trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Urbania on Rent in Kothrud Pune",
description: "Urbania on rent in Kothrud Pune offers reliable transportation for group travel. Customers can book vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania rentals."
},
{
name: "Force Urbania on Rent in Viman Nagar",
description: "Force Urbania on rent in Viman Nagar provides premium group travel options. Customers can book vehicles for airport and city travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Force Urbania on Rent in Wagholi Pune",
description: "Force Urbania on rent in Wagholi Pune offers convenient travel for groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania rentals."
},
{
name: "Pune to Nashik Urbania on Rent",
description: "Pune to Nashik Urbania on rent offers comfortable travel for group trips. Customers can book vehicles for religious and leisure travel. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily to Nashik with Urbania."
},
{
name: "Pune to Ashtavinayak Darshan Urbania on Rent",
description: "Pune to Ashtavinayak darshan Urbania on rent offers convenient travel for temple tours. Customers can book vehicles for group darshan trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Luxury Force Urbania on Rent in Hadapsar",
description: "Luxury Force Urbania on rent in Hadapsar provides premium travel for groups. Customers can book vehicles for events and tours. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury Urbania services."
},
{
name: "Luxury Force Urbania on Rent in Hinjewadi",
description: "Luxury Force Urbania on rent in Hinjewadi offers high-end travel for corporate and group trips. Customers can book vehicles easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania services in Hinjewadi."
},
{
name: "Luxury Force Urbania on Rent in Hinjewadi Near Me",
description: "Luxury Force Urbania on rent in Hinjewadi near me offers nearby booking options for customers. Users can find quick Urbania services locally. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book Urbania services near you easily."
},
{
name: "Pune to Goa Urbania Bus on Rent",
description: "Pune to Goa Urbania bus on rent offers comfortable travel for beach trips. Customers can book vehicles for group vacations. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily to Goa with Urbania services."
},
{
name: "Urbania Van on Rent Pune",
description: "Urbania van on rent Pune provides flexible travel options for group transportation. Customers can book vans for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Urbania vans."
},
{
name: "Urbania Bus on Rent Pune",
description: "Urbania bus on rent Pune offers reliable group travel solutions. Customers can book buses for long-distance trips and events. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Urbania bus services."
}
],

tableData: [
["Luxury Force Urbania on Rent in Pune","13 Seater Force Urbania on Rent in Pune"],
["17 Seater Force Urbania on Rent in Pune","Force Urbania for Rent in Pune"],
["Pune to Mahabaleshwar Urbania Bus on Rent","Pune to Shirdi Urbania on Rent"],
["Pune to Mumbai International Airport Urbania on Rent","Pune to Lonavala Urbania on Rent"],
["Pune to Kolhapur Urbania Hire","Urbania on Rent in Pimpri Chinchwad"],
["Urbania on Rent in Koregaon Park Pune","Urbania on Rent in Hadapsar"],
["Urbania on Rent in Kharadi Pune","Urbania on Rent in Kothrud Pune"],
["Force Urbania on Rent in Viman Nagar","Force Urbania on Rent in Wagholi Pune"],
["Pune to Nashik Urbania on Rent","Pune to Ashtavinayak Darshan Urbania on Rent"],
["Luxury Force Urbania on Rent in Hadapsar","Luxury Force Urbania on Rent in Hinjewadi"],
["Luxury Force Urbania on Rent in Hinjewadi Near Me","Pune to Goa Urbania Bus on Rent"],
["Urbania Van on Rent Pune","Urbania Bus on Rent Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Luxury Group Travel Vehicle",
    WhyChoosedescription: "SRS Cab Service offers Force Urbania on rent in Pune, a premium alternative to Tempo Traveller with spacious seating, modern interiors, and superior comfort for group travel."
  },
  {
    WhyChooseheading: "Affordable Urbania Rental Pricing",
    WhyChoosedescription: "We provide competitive Urbania rental in Pune with transparent pricing. Rates typically start from around ₹30–₹40 per km depending on seating capacity and trip type. :contentReference[oaicite:0]{index=0}"
  },
  {
    WhyChooseheading: "Multiple Seating Options Available",
    WhyChoosedescription: "Choose from 9, 10, 12, 13, and 17 seater Force Urbania vehicles, ideal for family trips, corporate outings, weddings, and group tours."
  },
  {
    WhyChooseheading: "Luxury Features & Comfortable Interiors",
    WhyChoosedescription: "Urbania vehicles come with pushback seats, ample legroom, AC, wide windows, and modern interiors, ensuring a premium travel experience for long journeys. :contentReference[oaicite:1]{index=1}"
  },
  {
    WhyChooseheading: "24/7 Urbania Rental Service",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Urbania bookings in Pune, making it easy to plan trips anytime for local sightseeing, airport transfers, and outstation tours."
  },
  {
    WhyChooseheading: "Best for Outstation & Tour Packages",
    WhyChoosedescription: "Our Urbania rental is perfect for Pune to Goa, Mahabaleshwar, Lonavala, Shirdi, and Konkan tours, offering comfortable long-distance travel for groups."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "We provide experienced drivers trained for highway and ghat driving, ensuring safe, smooth, and stress-free group travel."
  },
  {
    WhyChooseheading: "Trusted Urbania Rental Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for Urbania on rent in Pune due to reliable service, clean vehicles, and premium group travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Urbania on rent in Pune?", answer: "Yes, SRS Cab Service offers Force Urbania rental in Pune for local and outstation travel." },
  { question: "What is the price of Urbania in Pune?", answer: "Urbania rental in Pune starts from approximately ₹30 to ₹40 per km depending on seating and trip type." },
  { question: "Which seating options are available in Urbania?", answer: "We provide 9, 10, 12, 13, and 17 seater Force Urbania vehicles." },
  { question: "Is Urbania available for outstation trips?", answer: "Yes, Urbania is ideal for outstation travel like Goa, Mahabaleshwar, Shirdi, and Konkan tours." },
  { question: "Are Urbania vehicles AC?", answer: "Yes, all Urbania vehicles are fully air-conditioned with premium interiors." },
  { question: "Do you provide Urbania for weddings and corporate events?", answer: "Yes, Urbania is perfect for weddings, corporate travel, and group events." },
  { question: "Is Urbania available 24/7?", answer: "Yes, our Urbania rental service operates 24 hours a day." },
  { question: "What facilities are available in Urbania?", answer: "Facilities include AC, pushback seats, spacious interiors, luggage space, and entertainment options." },
  { question: "Can I book Urbania online?", answer: "Yes, you can easily book Urbania on rent in Pune online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all Urbania vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Jadhav",
    feedback:
      "Booked Urbania from SRS Cab Service for Goa trip. Very comfortable and premium experience for our group.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Kulkarni",
    feedback:
      "Best Urbania on rent in Pune. Spacious vehicle, smooth ride, and professional driver.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Force Urbania on rent in Pune including 13 and 17 seater options. Hire luxury Urbania for outstation trips, corporate events, family tours, and temple visits. Book online for Pune to Mahabaleshwar, Pune to Shirdi, Pune to Mumbai Airport, Pune to Lonavala, Pune to Kolhapur, and more with 24x7 booking and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Urbania On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Force Urbania on rent in Pune with SRS Cab. 13 and 17 seater options for outstation trips, corporate events, family tours, and temple visits. Book online for Pune to Mahabaleshwar, Pune to Shirdi, Pune to Mumbai Airport, Pune to Lonavala, Pune to Kolhapur, and more. 24x7 booking with affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpune;